import React, { ReactElement, useEffect } from "react";
import { ThunkDispatch } from "StoreTypes";
import Store from "~/common/Store";
import { updateUserAndChatFromOrigin } from "~/common/Store/actions/updateUserAndChatFromOrigin";

interface Props {
  title?: string | ReactElement;
  subTitle?: string | ReactElement;
  topRightButton: ReactElement;
  callToAction?: ReactElement;
  careersLinkTarget?: string;
  className?: string;
}

export default function CareersHeader({
  title,
  subTitle = "Gain on-the-job experience in an environment where company culture is top priority. Ready to start loving your job?",
  topRightButton,
  callToAction,
  careersLinkTarget = "_blank",
  className = "",
}: Props) {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (Store.dispatch as ThunkDispatch)(updateUserAndChatFromOrigin());
  }, []);

  return (
    <div className={`careers-header ${className}`}>
      <div className="careers-header-content">
        <span className="careers-header__logo">
          <a href="/" className="careers-header__logo-web" target="_blank">
            <img
              src="//cdnimg.webstaurantstore.com/uploads/design/2017/2/webstaurantstore-logo-careers.png"
              alt="WebstaurantStore"
            />
          </a>
          <a
            href="/careers"
            className="careers-header__logo-section"
            target={careersLinkTarget}
          >
            Careers
          </a>
        </span>
        {title && subTitle && (
          <div className="careers-header-text">
            <h1 className="careers-header__title title">{title}</h1>
            <p className="careers-header__subtitle">{subTitle}</p>
            {callToAction}
          </div>
        )}

        {topRightButton}
      </div>
    </div>
  );
}
